import React from "react";
import { Link } from "react-scroll";
import ProcessSvg from "../../assets/svg/process.svg";
import { useTranslation, Trans } from "react-i18next";

const Steps = () => {
  const { t } = useTranslation();
  return (
    <div className="bg-gray-100 py-6" id="how-it-works">
      <div className="container mx-auto max-w-7xl">
        <h2 className="text-3xl font-bold text-center">
          <Trans i18nKey="steps_heading" />
        </h2>
        <h3 className="text-center mt-1 mb-4 text-lg max-w-xs mx-auto">
          {t("steps_subheading")}
        </h3>
        <img src={ProcessSvg} alt="" />
        <div className="flex items-start">
          <p className="text-center w-1/5 ml-4 mt-3">
            {t("steps_calculate")}
          </p>
          <p className="w-1/5"></p>
          <p className="text-center w-1/5 mt-3">
            {t("steps_consult")}
          </p>
          <p className="w-1/5"></p>
          <p className="text-center w-1/5 mt-3">
            {t("steps_get_in_touch")}
          </p>
        </div>

        <Link
          to="calculator"
          smooth={true}
          duration={500}
          className="bg-red-600 text-white p-4 rounded-[58px] font-semibold mt-5 mx-auto block max-w-max cursor-pointer"
        >
          {t("steps_see_more")}
        </Link>
      </div>
    </div>
  );
};

export default Steps;
